import { Form, Input, InputType } from "decorator-form";

@Form ({title: "Timeline Config"})
export default class TimelineViewConfig {

	@Input({type: InputType.NUMBER, title: "Node Size"})
	public nodeSize: number = 40;

	@Input({type: InputType.NUMBER, title: "Spacer Length"})
	public spacerLength: number = 3;

	@Input({type: InputType.NUMBER, title: "Spacer Height"})
	public spacerHeight: number = 10;

	@Input({type: InputType.COLOR, title: "Active Color"})
	public activeColor: string = "blue";

	@Input({type: InputType.COLOR, title: "Inactive Color"})
	public inactiveColor: string = "grey";

	@Input({type: InputType.CHECKBOX, title: "Node Border"})
	public nodeBorder: boolean = true;
}



// WEBPACK FOOTER //
// ./src/common/views/timeline/TimelineViewConfig.tsx